/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ProjectBlockItem from 'shared/components/likiee/ProjectBlockItem';

const SearchProjects = ({ items, showAllTabs, onClickSeeMore }) => {
  const [showAll, setShowAll] = useState(!showAllTabs);
  const { t } = useTranslation();

  useEffect(() => {
    setShowAll(!showAllTabs);
  }, [showAllTabs]);

  if (!items?.length) {
    if (!showAllTabs) {
      return <p className='text-center'>{t('folders_no_result')}</p>;
    } else {
      return null;
    }
  }

  return (
    <div className='mb-4'>
      <h2 className='mb-10 d-flex align-items-center justify-content-between'>
        {t('title_projects')}
        {showAllTabs && items?.length > 5 && (
          <button className='btn text-underline p-0 text-primary' onClick={onClickSeeMore}>
            {t('text_see_all')}
          </button>
        )}
      </h2>
      <div className='d-flex row flex-wrap px-4 px-md-0'>
        {items?.map((item, i) => {
          if (!showAll && i > 4) return null;
          return <ProjectBlockItem item={item} key={i} />;
        })}
      </div>
      {!items?.length && <p className='col-12 mt-3  text-center text-secondary'>{t('project_no_result')}</p>}
    </div>
  );
};

export default SearchProjects;
